import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import classes from "./ParkingAllocationRadioButtons.module.css";
import Icons from "../../../resources/icons/Icons";
import { Button, Divider } from "@mui/material";
import Strings from "../../../resources/Strings";

const ParkingAllocationRadioButtons = (props) => {
  const [value, setValue] = React.useState(props?.occupiedTokens[0]?.id);

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const handleConfirm = () => {
    const selectedToken = props?.occupiedTokens?.find(
      (carToken) => carToken?.id == value
    );
    props.handleSelectedToken(selectedToken);
  };

  return (
    <div className={classes.parkingAllocationRadioButtons}>
      <FormControl classes={{ root: classes.formControl }}>
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={value}
          className={classes.radioGroup}
          onChange={handleChange}
        >
          {props?.occupiedTokens.map((carToken, idx) => {
            return (
              <FormControlLabel
                key={carToken?.id}
                value={carToken?.id}
                control={<Radio classes={{ checked: classes.checked }} />}
                classes={{ label: classes.label }}
                label={
                  <div className={classes.tokenDetails}>
                    <div className={classes.summaryText}>
                      <span>Allocation {idx + 1}</span>
                      {carToken?.token?.isBillingEnabled && (
                        <img
                          className={classes.payingIcon}
                          src={Icons.PAYING}
                        />
                      )}
                    </div>
                    <div>{carToken?.token?.displayValue}</div>
                  </div>
                }
              />
            );
          })}
        </RadioGroup>
      </FormControl>
      <Divider />
      <div className={classes.action}>
        <Button className={classes.confirmButton} onClick={handleConfirm}>
          {Strings.CONFIRM_AND_CONTINUE}
        </Button>
      </div>
    </div>
  );
};

export default ParkingAllocationRadioButtons;
